import moment from 'moment';

/** The chart's x-axis is a `datetime` axis keyed by each day's UTC start-of-day timestamp. */
export function dayTimestamp(date: string): number {
  return moment.utc(date).startOf('day').valueOf();
}
